import api from './api';
import { API_COMMANDS } from './commands';

const updateUserInfo = async (fields) => {
  const response = await api.post('', fields, {
    params: { command: API_COMMANDS.USER_INFO_UPDATE },
  });
  return response.data;
};

export default updateUserInfo;
